export default __webpack_public_path__ + "2e6d986fe4259a0f8a2f34135c876053.png";